import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fl-dummy-component',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DummyComponent {}
